import api from './api';

const blacklistService = {
  // Get all blacklist words
  getBlacklistWords: async () => {
    const response = await api.get('/blacklist');
    return response.data;
  },
  
  // Add new blacklist word
  addBlacklistWord: async (word) => {
    const response = await api.post('/blacklist', { word });
    return response.data;
  },
  
  // Add multiple blacklist words
  addBulkBlacklistWords: async (words) => {
    const response = await api.post('/blacklist/bulk', { words });
    return response.data;
  },
  
  // Delete blacklist word
  deleteBlacklistWord: async (id) => {
    const response = await api.delete(`/blacklist/${id}`);
    return response.data;
  },
  
  // Test message against blacklist
  testMessage: async (message) => {
    const response = await api.post('/blacklist/test', { message });
    return response.data;
  },
  
  // Export blacklist words
  exportBlacklistWords: async () => {
    const response = await api.get('/blacklist/export');
    return response.data;
  }
};

export default blacklistService;
